export const REQUIRED_OPEN_DAYS = 7;

export const SPIN_WHEEL_FRUITS = ['Banana', 'Orange', 'Mango', 'Melon', 'Strawberry', 'Pineapple'];

const padDatePart = (value) => String(value).padStart(2, '0');

export const getLocalDateKey = (date = new Date()) =>
  `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(date.getDate())}`;

const normalizeOpenDaysCount = (openDaysCount) => {
  const count = Number(openDaysCount);

  if (!Number.isFinite(count) || count < 0) {
    return 0;
  }

  return Math.min(Math.floor(count), REQUIRED_OPEN_DAYS);
};

const normalizeSpinsAvailable = (spinsAvailable) => {
  const count = Number(spinsAvailable);

  if (!Number.isFinite(count) || count < 0) {
    return 0;
  }

  return Math.floor(count);
};

const normalizeCollectedFruits = (fruits) => {
  if (!Array.isArray(fruits)) {
    return [];
  }

  return [...new Set(fruits)].filter((fruit) => SPIN_WHEEL_FRUITS.includes(fruit));
};

export const createDefaultSpinWheelProgress = (sessionId, today = getLocalDateKey()) => ({
  session_id: sessionId,
  last_counted_open_date: today,
  open_days_count: 1,
  spins_available: 0,
  last_spin_at: null,
  fruits: SPIN_WHEEL_FRUITS,
  collected_fruits: [],
});

export const normalizeSpinWheelProgress = (progress, sessionId) => {
  const openDaysCount = normalizeOpenDaysCount(progress?.open_days_count);
  const spinsAvailable = normalizeSpinsAvailable(progress?.spins_available);

  return {
    session_id: progress?.session_id || sessionId,
    last_counted_open_date: progress?.last_counted_open_date || null,
    open_days_count: openDaysCount,
    spins_available: openDaysCount >= REQUIRED_OPEN_DAYS ? Math.max(spinsAvailable, 1) : spinsAvailable,
    last_spin_at: progress?.last_spin_at || null,
    fruits: Array.isArray(progress?.fruits) && progress.fruits.length > 0 ? progress.fruits : SPIN_WHEEL_FRUITS,
    collected_fruits: normalizeCollectedFruits(progress?.collected_fruits),
  };
};

export const applyAppOpenToProgress = (progress, today = getLocalDateKey()) => {
  const normalizedProgress = normalizeSpinWheelProgress(progress, progress?.session_id);

  if (normalizedProgress.last_counted_open_date === today) {
    return normalizedProgress;
  }

  const openDaysCount = Math.min(normalizedProgress.open_days_count + 1, REQUIRED_OPEN_DAYS);

  return {
    ...normalizedProgress,
    last_counted_open_date: today,
    open_days_count: openDaysCount,
    spins_available: openDaysCount >= REQUIRED_OPEN_DAYS ? Math.max(normalizedProgress.spins_available, 1) : 0,
  };
};

export const consumeSpinWheelProgress = (progress, now = new Date()) => ({
  ...normalizeSpinWheelProgress(progress, progress?.session_id),
  last_counted_open_date: getLocalDateKey(now),
  open_days_count: 0,
  spins_available: Math.max(normalizeSpinsAvailable(progress?.spins_available) - 1, 0),
  last_spin_at: now.toISOString(),
});

export const getRemainingOpenDays = (progress) =>
  Math.max(REQUIRED_OPEN_DAYS - normalizeOpenDaysCount(progress?.open_days_count), 0);

export const isSpinWheelEligible = (progress) => normalizeSpinsAvailable(progress?.spins_available) > 0;
